import * as config from "./config"

// 根据资讯类别编码查询资讯类别以及其子类别
export const GetInformatioCategoryn = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/information/category/tree/'

// 资讯分页条件查询
export const GetInformatio = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/information/page'

//查看资讯单个文章
export const GetNewsInfo = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/information/'

//查看资讯分类下的单个文章
export const GetInfo = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/information/category/'

//资讯列表，根据权重排序
export const GetRankingList = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/information/list'
//查询关于我们
export const aboutUsListURl = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/cms/aboutUsList'
//查询科普教育树
export const sciencecategoryUrl = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/science/categoryTree'
//查询科普教育
export const educationListUrl = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/education/educationList'
//查询资源工具
export const toolListURl = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/resource/toolList'
//查询科普产品分类
export const productTypeListURl = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/resource/productTypeList'
//查询科普产品分类列表
export const productListURl = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/resource/productList'
//查询国家标准列表
export const nationalStandardListURl = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/resource/nationalStandardList'
//资源工具-科普教育详情
export const productDeseURl = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/resource/product/'
//科普教育-科普教育详情
export const educationDeseURl = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/education/education/'

//科学数据-获取火星数据
export const scienceCategoryURl = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/science/categoryTree'

//科学数据-获取科学数据
export const scienceCatalogueURl = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/science/catalogue'


//科学数据-获取科学数据
export const dataTaskDescListURl = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/science/dataTaskDescList'
//科学数据-获取数据说明
export const dataExplainListURl = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/science/dataExplainList'
//科学数据-引用致谢
export const dataQuteThankListURl = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/science/dataQuteThankList'
//科学数据-版权声明
export const copyrightListURL = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/science/copyrightList'

//科学数据-数据详情列表检索
export const dataInfoListURL = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/science/dataInfoList'

//PDS-卷集
export const pdsDatasetURL = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/psd/pdsDataset'

//收藏科学数据
// export const sciencebookmarkaddURL = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/science/bookmark/add'
// export const sciencebookmarkdelURL = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/science/bookmark/del'

export const batchSciencebookmarkaddURL = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/science/bookmark/add'
export const batchSciencebookmarkdelURL = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/science/bookmark/del'
// 科学目录下载申请
export const catalogueReviewApply = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/catalogueReview/apply/'


export const getAnnexZipURl = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/science/dataInfo/getAnnexZip/'
export const downloadURl = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/common/download'


// 获取科学数据类型
export const getDataType = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/science/category/-1'


// 查询任务介绍的载荷列表
export const taskDescLoadlist = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/science/taskDescLoadList'

//科普教育获取浏览最高前4位
export const top4EducationList = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/education/top4EducationList'


// 获取科学载荷数据
export const getTypeData = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/science/category'


// 杏询科学教育数据引用说明列表
export const getEducationQuteList = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/education/educationQuteList'

// 下载pds
export const psdAnnexZipUrl = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/psd/getAnnexZip/'

// 批量下载科学数据
export const getBatchAnnexZip = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/science/dataInfo/getBatchAnnexZip'

